import client from '../appolloConfig';

const logout = async () => {
  client
    .resetStore()
    .then(() => {
      localStorage.clear();
      window.location.assign('/');
    })
    .catch(() => {
      localStorage.clear();
      window.location.assign('/');
    });
};
export default logout;
